<div class="navbar-start">
    <a *ngFor="let link of links" routerLink="{{link.link}}" routerLinkActive="is-active" class="navbar-item">{{link.name}}</a>
</div>
<grt-login-status class="navbar-end"></grt-login-status>
